import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { formatDateToMMDDYYYY } from '../../../../../core/functions/date-helpers';
import { ApplicationStatusCellRendererParams } from './models/application-status-cell-renderer-params';

@Component({
    selector: 'app-application-status-cell-renderer',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './application-status-cell-renderer.component.html',
})
export class ApplicationStatusCellRendererComponent
    implements ICellRendererAngularComp
{
    params!: ApplicationStatusCellRendererParams;

    readonly formatDateToMMDDYYYY = formatDateToMMDDYYYY;

    agInit(params: ApplicationStatusCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }
}
